import styled from "styled-components";
import { Corpo as CorpoBase } from "../Conteudo/styled";

// Mesmo corpo das listas de Conteúdo, mais as células próprias de Grupos.
export const Corpo = styled(CorpoBase)`
  .grupo-nome{
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    > div{ display: flex; flex-direction: column; min-width: 0; }
    .seta{ color: #6B6E70; font-weight: 400; }
  }
  .capa-mini{
    flex: none;
    width: 48px;
    height: 36px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #E1E3E6;
    background: #F7F8F9;
  }
  /* o esqueleto de imagem (App.css) tem min-height 120px: aqui a miniatura e pequena. */
  .capa-mini[data-carregando="true"]{ min-height: 0; }
  .numero{ font-variant-numeric: tabular-nums; }
  .selo.grupo{ background: #fff; color: #1f7a33; border-color: #BFE0C5; }
  .selo.subgrupo{ background: #E8EEF5; color: #26466D; border-color: #C6D3E3; }
`;
